/**
 * 设备子标签页定义 —— 被 Sidebar 的 SessionBlock 和 Devices grid 的
 * DeviceCard 共用。每个条目就是 `/devices/:serial<toSuffix>` 这条
 * sub-route。
 *
 * 抽到 lib 而不是从 Sidebar 导出，是因为 DeviceCard 也要复用，避免
 * UI 组件之间的循环 import 关系。
 */
import {
  Activity,
  Boxes,
  Gauge,
  Globe,
  HardDrive,
  LayoutGrid,
  ScrollText,
  Terminal,
  Workflow,
  type LucideIcon,
} from 'lucide-react';

export interface DeviceSubTab {
  /** 拼到 `/devices/:serial` 后面的后缀；空串 = Overview。 */
  toSuffix: string;
  /** react-router `useMatch` 用的模式，包含 `:serial` 占位符。 */
  matchPattern: string;
  /** Sidebar / DeviceCard 显示的人类标签（中文 · 英文）。 */
  label: string;
  /** 同上，但 DeviceCard 的紧凑 icon row 用得到（仅中文，省版面）。 */
  shortLabel: string;
  /** Lucide 图标。 */
  icon: LucideIcon;
}

export const DEVICE_SUB_TABS: DeviceSubTab[] = [
  { toSuffix: '', matchPattern: '/devices/:serial', label: '概览 · Overview', shortLabel: '概览', icon: Gauge },
  { toSuffix: '/control', matchPattern: '/devices/:serial/control', label: 'WS 命令 · WS Commands', shortLabel: 'WS', icon: Terminal },
  { toSuffix: '/network', matchPattern: '/devices/:serial/network', label: '网络 · Network', shortLabel: '网络', icon: Globe },
  { toSuffix: '/apps', matchPattern: '/devices/:serial/apps', label: '应用 · Apps', shortLabel: '应用', icon: Boxes },
  { toSuffix: '/perf', matchPattern: '/devices/:serial/perf', label: '性能 · Performance', shortLabel: '性能', icon: Activity },
  { toSuffix: '/inspector', matchPattern: '/devices/:serial/inspector', label: '布局 · Layout', shortLabel: '布局', icon: LayoutGrid },
  { toSuffix: '/commands', matchPattern: '/devices/:serial/commands', label: 'ADB cmd', shortLabel: 'ADB', icon: Workflow },
  { toSuffix: '/logs', matchPattern: '/devices/:serial/logs', label: '日志 · Logcat', shortLabel: '日志', icon: ScrollText },
  { toSuffix: '/files', matchPattern: '/devices/:serial/files', label: '文件 · Files', shortLabel: '文件', icon: HardDrive },
];
